import { useClientPortalConfigContext } from "../../../context";
import { UseMutateAsyncFunction } from "@tanstack/react-query";
import { usePostMutation } from "../../../hooks/useClientPortalQuery";

export interface IUserLogoutHook {
    isLoading: boolean;
    logout: UseMutateAsyncFunction;
}

export function useClientPortalUserLogout(): IUserLogoutHook {
    const { clientPortalGuid } = useClientPortalConfigContext();

    const { isPending, mutateAsync } = usePostMutation({
        url: `/api/v1/${clientPortalGuid}/Auth/LogOut`,
    });

    return {
        isLoading: isPending,
        logout: mutateAsync,
    };
}
